<dsy-card class="card-container"  [noPadding]="true">
  <dr-flex-home-ui-app-offers class="card-content">
    <div class="demand-component__header">
      <div class="demand-component__summary">
        <div class="card-content__title">
          <dr-flex-home-ui-widget-header [title]="'FLEX_HOME.COM_WIDGET.DEMAND.TITLE' | translate" [customRightWidget]="true">
            <dsy-icon
              class="card-content__info-icon"
              customRightWidget
              pTooltip="{{ 'FLEX_HOME.COM_WIDGET.DEMAND.TOOLTIP' | translate }}"
              tooltipPosition="bottom"
              class="card-content__info-icon"
              [name]="'info'"
              [size]="'0.8rem'"
            ></dsy-icon>
          </dr-flex-home-ui-widget-header>
        </div>
      <div class="demand-component__title">
          @if (myDemand() && total()) {
            <div class="demand-component__total">
              <h2>
                {{ total()!.toFixed(1) }}
              </h2>
              <p>{{ 'FLEX_HOME.COMMON.UNIT_KW' | translate }}</p>
            </div>
          }
        </div>
      </div>
        <div class="demand-component__sites-selector">
          @if (myDemand()) {
            <div class="drop-down">
              @if (sitesDropDownList().length > 1) {
                <dsy-input-dropdown
                  [ngClass]="{
                    'drop-down__not-empty': selectedSites().length > 0,
                    'drop-down__full': selectedSites().length >= maxSelections,
                  }"
                  [entries]="sitesDropDownEntries()"
                  [renderCounterTag]="showDropDownTag()"
                  label="{{ 'FLEX_HOME.COM_WIDGET.DEMAND.LABELS.SITES' | translate }}"
                  density="wide"
                  [customDsyListConfObject]="dropDownListConfig()"
                  [counterTagConfig]="dropDownTagConfig"
                ></dsy-input-dropdown>
              } @else if (sitesDropDownList().length === 0) {
                <dsy-input-dropdown
                  [entries]="[{ id: 'no-sites', isSelected: true }]"
                  [isDisabled]="true"
                  density="wide"
                  label="{{ 'FLEX_HOME.COM_WIDGET.DEMAND.LABELS.SITES' | translate }}"
                ></dsy-input-dropdown>
              } @else {
                <div></div>
              }
            </div>
            <p>{{ myDemand()!.lastUpdate |  demandDate:locale()}}</p>
          }
        </div>
      </div>
    <div class="demand-component">
      @if (myDemand()) {
        @if (!myDemand()!.sites || myDemand()!.sites.length === 0) {
          <dr-flex-home-ui-empty-state class="empty" [showPermissionStatus]="true" [title]="'FLEX_HOME.COM_WIDGET.DEMAND.NO_DATA'"></dr-flex-home-ui-empty-state>
        } @else if (selectedSites().length === 0) {
          <dr-flex-home-ui-empty-state class="empty" [showPermissionStatus]="true" [title]="'FLEX_HOME.COM_WIDGET.DEMAND.NO_DATA'"></dr-flex-home-ui-empty-state>
        } @else if (selectedSites().length !== 0) {
          <dsy-table class="demand-table" [data]="tableData()" [conf]="tableConf()">
            @for (column of columnsDefinition; track $index) {
              <p class="demand-table__header" [attr.slot]="`header-${column.key}`">
                {{ column.header | translate }}
              </p>
            }
            @for (site of selectedSites(); track $index) {
              <p slot="cell-{{ $index }}-site" class="demand-table__site-text" pTooltip="{{ site.name | displayLocale: null : 'label' }}">
                {{ site.name | displayLocale: null : 'label' }}
              </p>

              <div slot="cell-{{ $index }}-min" class="demand-table__icon-cell" >
                @if (site.min && site.min !== 0) {
                  <dsy-icon name="arrow_downward" library="material" [size]="'1rem'" color="#667790"></dsy-icon>
                }
                <p class="demand-table__text">{{ site.min ? site.min.toFixed(1) : '-' }} {{ 'FLEX_HOME.COMMON.UNIT_KW' | translate }}</p>
              </div>

              <div slot="cell-{{ $index }}-max" class="demand-table__icon-cell">
                @if (site.max && site.max !== 0) {
                  <dsy-icon name="arrow_upward" library="material" [size]="'1rem'" color="#667790"></dsy-icon>
                }
                <p class="demand-table__text">{{ site.max ? site.max.toFixed(1) : '-' }} {{ 'FLEX_HOME.COMMON.UNIT_KW' | translate }}</p>
              </div>

              <p slot="cell-{{ $index }}-average" class="demand-table__text">{{ site.average ? site.average.toFixed(1) : '-' }} {{ 'FLEX_HOME.COMMON.UNIT_KW' | translate }}</p>

              <div slot="cell-{{ $index }}-demand" class="demand-table__progress-bar-cell">
                <p>
                  {{ total() === 0 || site.demand === 0 ? '-' : ((site.demand / total()!) * 100).toFixed(0) + '%' }}
                </p>
                <mat-progress-bar
                  class="demand-table__progress-bar"
                  mode="determinate"
                  [value]="(site.demand / total()!) * 100"
                  [style.visibility]="site.demand === 0 ? 'hidden' : 'visible'"
                ></mat-progress-bar>
              </div>

              <p>
                {{ site.share }}
              </p>
            }
          </dsy-table>
        }
        
      } @else {
        <div class="loading-spinner">
          <dsy-loader type="spinner" size="xx-small" animation-speed="slow"></dsy-loader>
        </div>
      }
    </div>
  </dr-flex-home-ui-app-offers>
  <dr-flex-home-ui-link-button
          class="demand-component__button"
          [link]="{ text: ('FLEX_HOME.COM_WIDGET.GO_TO_TRENDS' | translate), href: trendsUrl }"
          size="md"
          [mixpanelClickEvent]="mixPanelEvent.CLICK_GO_TRENDS"
        />
</dsy-card>
